import './UsageChart.css';

export default function UsageChart({ stats, limit = 30 }) {
  if (!stats || stats.length === 0) {
    return (
      <div className="usage-empty chiron-goround-tc-body">
        <p>Aucune donnée d'utilisation disponible.</p>
      </div>
    );
  }

  const displayed = stats.slice(0, limit);
  const maxUsage = displayed[0]?.usagePercentage || 1;

  return (
    <div className="usage-grid">
      {displayed.map((pokemon, index) => (
        <div key={pokemon.name} className="usage-card">
          <div className="usage-card__rank staatliches-regular">
            #{index + 1}
          </div>

          <div className="usage-card__image-wrapper">
            {pokemon.spriteUrl ? (
              <img
                src={pokemon.spriteUrl}
                alt={pokemon.name}
                className="usage-card__image"
                loading="lazy"
              />
            ) : (
              <div className="usage-card__image-placeholder">?</div>
            )}
          </div>

          <div className="usage-card__name chiron-goround-tc-bold">
            {pokemon.name}
          </div>

          <div className="usage-card__percentage staatliches-regular">
            {pokemon.usagePercentage}%
          </div>

          <div className="usage-card__meta chiron-goround-tc-light">
            <span>{pokemon.usageCount} équipes</span>
            <span>{pokemon.tournamentCount} tournoi{pokemon.tournamentCount > 1 ? 's' : ''}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
